import React from "react";
import Api from "./Api/Communicator";

export default class DpdShips extends React.Component {
    state={
        filterValue: "",
        newShip: {
            open: false,
            note: "",
            name: "",
            street: "",
            city: "",
            zip: "",
            phone: "",
            email: "",
            ref1: "",
            ref2: "",
            ref3: "",
            COD: 1425.10,
            isCOD: 0,
            isPickup: 0
        },
        data: [{
            id: 145274,
            ServisId: 146646,
            TranspCode: "13945652598452",
            DateCreate: "2023-06-22",
            COD: 1425.10,
            ref1: "145274",
            ref2: "45184sd8s8d",
            ref3: "9s4a8d48a4d8sa",
            note: "TEST 123",
            name: "Tester Testovič",
            street: "Testovací 123",
            city: "Testovo",
            zip: "100 00",
            phone: "+420 777 777 777",
            email: "tester@testovic.test"
        }],

    }

    filterFunc = (data) => {
        const fulltext = JSON.stringify(data);
        return (
          fulltext.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) > -1
        );
      };

    render() {
        const {Bs, SIZE, Icon} = this.props;
        return(
        <>
        {this.state.newShip.open && (
            <Bs modal
            show={this.state.newShip.open}
            onHide={() => this.setState({ newShip: {...this.state.newShip,open: false} })}
            centered
            size={SIZE.LG}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static">
                <Bs modalheader closeButton>
                    Založit novou přepravu    
                </Bs>
                <Bs modalbody>
                    <Bs row>
                    <Bs col xs={12} lg={4}>
                            <Bs formtext>Reference</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                            <Bs formtext>Reference 2</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                            <Bs formtext>Reference 3</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={6}>
                            <Bs formtext>Název</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={6}>
                            <Bs formtext>Název 2</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={5}>
                            <Bs formtext>Ulice</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                            <Bs formtext>Město</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={3}>
                            <Bs formtext>PSČ</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={6}>
                            <Bs formtext>Email</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12} lg={6}>
                            <Bs formtext>Telefon</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={6} >
                            <Bs formtext>Dobírka</Bs>
                            <Bs formswitch />
                        </Bs>
                        <Bs col xs={6}>
                            <Bs formtext>Dobírka cena</Bs>
                            <Bs formcontrol />
                        </Bs>
                        <Bs col xs={12}>
                            <Bs formtext>Poznámka</Bs>
                            <Bs formcontrol as="textarea" rows="3"/>
                        </Bs>
                    </Bs>
                </Bs>
                <Bs modalfooter>
                    <Bs button variant="transparent" className="me-2" size="sm">Zrušit</Bs>
                    <Bs button variant="success" size="sm">Vytvořit</Bs>
                </Bs>
            </Bs>
        )}
        <div class="p-3 mb-4 bg-uni rounded">
          <div class="d-flex justify-content-between align-items-start align-items-md-center">
            <div>
              <span class="text-secondary mr-1 me-2">Použité filtry:</span>
              <span>
                <strong>
                  {this.state.filterValue === ""
                    ? "Bez filtru"
                    : this.state.filterValue}
                </strong>
              </span>
            </div>
            <Bs col xs={5} className="d-flex justify-content-end">
              <Bs
                formcontrol
                placeholder="Hledat"
                className="me-2"
                value={this.state.filterValue}
                onChange={(e) => this.setState({ filterValue: e.target.value })}
              />
            </Bs>
          </div>
          <Bs row className="mt-2">
            <Bs col xs={12} lg={4} className="d-flex justify-content-start">
              <Bs row>
                <Bs col xs={12}>
                  <Bs formtext>Datum od</Bs>
                </Bs>
                <Bs col xs={12}>
                  <Bs
                    formcontrol
                    type="date"
                    placeholder="Hledat"
                    className="me-2"
                    value={this.state.filterValue}
                    onChange={(e) =>
                      this.setState({ filterValue: e.target.value })
                    }
                  />
                </Bs>
              </Bs>
            </Bs>
            <Bs col xs={12} lg={4} className="d-flex justify-content-start">
              <Bs row>
                <Bs col xs={12}>
                  <Bs formtext>Datum do</Bs>
                </Bs>
                <Bs col xs={12}>
                  <Bs
                    formcontrol
                    type="date"
                    placeholder="Hledat"
                    className="me-2"
                    value={this.state.filterValue}
                    onChange={(e) =>
                      this.setState({ filterValue: e.target.value })
                    }
                  />
                </Bs>
              </Bs>
            </Bs>
            <Bs col xs={12} lg={4} className="d-flex justify-content-end align-items-end">
              <Bs row>
                <Bs col xs={12}>
                    <Bs button size="sm" variant="success" className="me-4">Vyhledat</Bs>
                    <Bs button size="sm" variant="warning" disabled={this.state.newShip.open} onClick={()=>this.setState({newShip: {...this.state.newShip,open:true}})}>Nový rozvoz</Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </div>
        
        
        {this.state.data.filter(this.filterFunc).map((e,idx)=>(
            <Bs row className="mt-2">
                <Bs col xs={12}>
                <Bs card className="lb-3-warning">
                <Bs cardbody>
                    <Bs row>
                        <Bs col xs={2} className="d-flex justify-content-start align-items-center mb-2">
                            <Bs span><strong>{e.TranspCode}</strong></Bs>
                        </Bs>
                        <Bs col xs={10} className="d-flex justify-content-end align-items-center mb-2">
                            <Icon iotrashoutline data-tip="Smazat přepravu" className="fs-20 c-red cursor-pointer me-4" />
                            <Icon aioutlinemail data-tip="Znovu informovat zákazníka" className="fs-20 cursor-pointer me-4" />
                            <Icon aioutlineprinter data-tip="Vytisknout štítek" className="fs-20 cursor-pointer me-4" />
                            <Icon gideertrack data-tip="Sledovat zásilku" className="fs-20 cursor-pointer me-4" />
                            <Icon golinkexternal data-tip="Přejít na stránky dopravce" className="fs-20 cursor-pointer" />
                        </Bs>
                        <Bs col xs={12} lg={4}>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Id:</strong></Bs>
                            <Bs span>{e.id}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Číslo přepravy:</strong></Bs>
                                <Bs span>{e.TranspCode}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Datum objecnávky:</strong></Bs>
                                <Bs span>{new Date(e.DateCreate).toLocaleDateString()}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Celková cena:</strong></Bs>
                                <Bs span>{e.COD}</Bs>
                                </Bs>
                            </Bs>
                        </Bs>
                        <Bs col xs={12} lg={4}>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Jméno:</strong></Bs>
                                <Bs span>{e.name}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Adresa:</strong></Bs>
                                <Bs span>{e.street}, {e.city} {e.zip}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Email:</strong></Bs>
                                <Bs span>{e.email}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Telefon:</strong></Bs>
                                <Bs span>{e.phone}</Bs>
                                </Bs>
                            </Bs>
                        </Bs>
                        <Bs col xs={12} lg={3}>
                        <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>REF1:</strong></Bs>
                            <Bs span>{e.ref1}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>REF2:</strong></Bs>
                            <Bs span>{e.ref2}</Bs>
                                </Bs>
                            </Bs>
                            <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>REF3:</strong></Bs>
                            <Bs span>{e.ref3}</Bs>
                                </Bs>
                            </Bs>
                        <Bs row>
                                <Bs col xs={12}>
                                <Bs small className="text-muted me-2"><strong>Poznámka:</strong></Bs>
                            <Bs span>{e.note}</Bs>
                                </Bs>
                            </Bs>
                            
                        </Bs>
                    </Bs>
                </Bs>
            </Bs>
                </Bs>
            </Bs>
            
        ))}
        </>
        );
    }
}
